import { Component, Input, NgZone, OnInit, ViewChild } from '@angular/core';
import { take } from 'rxjs/operators';
import { GridComponent, GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { process, State, orderBy } from '@progress/kendo-data-query';
import { CSEService } from '../../services/cse.service';
import { UtilService } from '../../services/util.service';
import {
    CarrierService
    , QuoteOrderLineCarrierServiceMap
    , SearchQuoteOrderLineCarrierService
} from '../../models/models';

@Component({
    selector: 'quoteorderline-carrier-service-assigned',
    templateUrl: './quoteorderline-carrier-service-assigned.component.html',
    standalone: false
})
export class QuoteOrderLineCarrierServiceAssigned implements OnInit {
    @Input() quoteOrderLineID: number = 0;
    @Input() loadStatus: string = "";

    @ViewChild(GridComponent, { static: false }) public carrierServiceGrid!: GridComponent;

    //public selectedCarrierServices: Employee[] = [];
    public carrierServiceList: CarrierService[] = [];
    public loadServiceMapList: QuoteOrderLineCarrierServiceMap[] = [];
    public loadServiceList: SearchQuoteOrderLineCarrierService[] = [];
    public carrierServiceIDList: number[] = [];

    public gridData: GridDataResult = { data: [], total: 0 };
    public gridState: State = { skip: 0, take: 10, sort: [{ dir: 'asc', field: 'abbreviation' }] };

    constructor(private cseService: CSEService, private utilService: UtilService, private ngZone: NgZone) {
    }

    ngOnInit() {
        this.getCarrierServices();
        // load requireed service map table
        // need OverrideNotes, OverrideEmployeeID
        // set services in loads grid
        // validate services assigned in award carrier vs. carrier services
        // add flag for CarrierService for used for loads: "Used for Load Service Requirements"
    }

    public canEdit() {
        if (this.loadStatus == "Planned" || this.loadStatus == "Available") {
            return true;
        }
        else {
            return false;
        }
    }

    private getCarrierServices() {
        this.utilService.isLoading = true;
        this.cseService.getCarrierServicesRequiredForLoads().subscribe(result => {
            this.utilService.isLoading = false;
            this.carrierServiceList = result;
            this.getCarrierServiceMaps();
        });
    }

    private getCarrierServiceMaps() {
        this.utilService.isLoading = true;
        this.cseService.getSearchQuoteOrderLineCarrierServiceByQuoteOrderLineID(this.quoteOrderLineID).subscribe(result => {
            this.loadServiceList = result;

            this.cseService.getQuoteOrderLineServiceMapsByQuoteOrderLineID(this.quoteOrderLineID).subscribe(result2 => {
                this.utilService.isLoading = false;

                this.loadServiceMapList = result2;

                if (result2 != null) {
                    result2.forEach(s => {
                        this.carrierServiceIDList.push(s.carrierServiceID);
                        var service = this.carrierServiceList.find(t => t.carrierServiceID == s.carrierServiceID);
                        if (service != null) {
                            service.isChecked = true;
                        }
                    });
                }

                this.setGrid();
            });
        });
    }

    private setGrid() {
        if (this.gridState.sort) this.carrierServiceList = orderBy(this.carrierServiceList, this.gridState.sort);

        this.gridData = process(this.carrierServiceList, this.gridState);
        this.fitColumns();
    }

    private fitColumns() {
        this.ngZone.onStable.asObservable().pipe(take(1)).subscribe(() => {
            if (this.carrierServiceGrid == null) return;
            this.carrierServiceGrid.autoFitColumns();
        });
    }

    public dataStateChange(state: DataStateChangeEvent) {
        this.gridState = state;
        this.setGrid();
    }

    public getOverrideInfo(carrierServiceID: number) {
        var serviceMap = this.loadServiceList.find(t => t.carrierServiceID == carrierServiceID);
        var info = "";
        if (serviceMap != null && serviceMap.overrideManagerEmployeeID! > 0) {
            info += "<label class='fw-bold'>By:</label> " + serviceMap.overrideEmployeeName + "<br />";
            info += "<label class='fw-bold'>Mgr:</label> " + serviceMap.overrideManagerEmployeeName + "<br />";
            info += "<label class='fw-bold'>Note:</label> " + serviceMap.overrideNote + "<br />";
            info += "<label class='fw-bold'>Date:</label> " + serviceMap.overrideDate + "<br />";
        }
        else {
            info = "";
        }
        return info;
    }

    public setServiceMap(service: CarrierService) {
        service.isChecked = !service.isChecked;
        this.saveServiceMaps(service);
    }

    public saveServiceMaps(service: CarrierService) {
        var idx = this.carrierServiceIDList.indexOf(service.carrierServiceID);
        if (!service.isChecked && idx >= 0) {
            this.carrierServiceIDList.splice(idx, 1);
        }
        else if (idx < 0) {
            this.carrierServiceIDList.push(service.carrierServiceID);
        }

        console.log("saveServiceMaps", idx, this.carrierServiceIDList, service);

        let maps: QuoteOrderLineCarrierServiceMap[] = [];

        if (this.carrierServiceIDList.length > 0) {
            var employeeID = parseInt(localStorage.getItem('EmployeeId')!);
            this.carrierServiceIDList.forEach(s => {
                var map = {
                    quoteOrderLineID: this.quoteOrderLineID,
                    carrierServiceID: s,
                    quoteOrderLineCarrierServiceMapID: 0
                } as QuoteOrderLineCarrierServiceMap;

                maps.push(map);
            });

            this.utilService.isLoading = true;
            this.cseService.saveQuoteOrderLineCarrierServiceMapList(maps).subscribe(result => {
                this.utilService.isLoading = false;
                this.getCarrierServiceMaps();
            });
        } else {
            this.utilService.isLoading = true;
            this.cseService.deleteQuoteOrderLineCarrierServiceMapsByQuoteOrderLineID(this.quoteOrderLineID).subscribe(result => {
                this.utilService.isLoading = false;
                this.getCarrierServiceMaps();
            });
        }
    }
}
